import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import AppLayout from "../../../components/ui/AppLayout";
import PageHeader from "../../../components/ui/PageHeader";
import SectionCard from "../../../components/ui/SectionCard";
import LoadingState from "../../../components/ui/LoadingState";
import PlayerAvatar from "../../../components/ui/PlayerAvatar";
import TeamCrest from "../../../components/ui/TeamCrest";
import api from "../../../api";
import tokens from "../../../theme/tokens";

const VotarMelhorJogadorPage = () => {
  const [apartamento, setApartamento] = useState("");
  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [jogadores, setJogadores] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isVoting, setIsVoting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const CACHE_KEY_JOGADORES = "jogadoresCache";
  const CACHE_EXPIRATION = 1 * 24 * 60 * 60 * 1000; // 3 dias em milissegundos

  useEffect(() => {
    const fetchJogadores = async () => {
      setIsLoading(true);
      try {
        // Verifique se há um cache existente e se ele ainda é válido
        const cachedData = localStorage.getItem(CACHE_KEY_JOGADORES);
        const cachedTimestamp = localStorage.getItem(
          `${CACHE_KEY_JOGADORES}_timestamp`
        );

        const cacheTorneio = localStorage.getItem("TORNEIO_ID");
        const cacheTorneioTimestamp = localStorage.getItem(
          `${"TORNEIO_ID"}_timestamp`
        );
        let times;
        let torneio;
        if (cachedData && cachedTimestamp) {
          const currentTime = new Date().getTime();
          if (currentTime - parseInt(cachedTimestamp, 10) <= CACHE_EXPIRATION) {
            // Cache válido, use os dados em cache
            // setTimes(JSON.parse(cachedData));
            times = JSON.parse(cachedData);
          }
        }
        if (cacheTorneio && cacheTorneioTimestamp) {
          const currentTime = new Date().getTime();
          if (
            currentTime - parseInt(cacheTorneioTimestamp, 10) <=
            CACHE_EXPIRATION
          ) {
            // Cache válido, use os dados em cache
            // setTimes(JSON.parse(cachedData));
            torneio = JSON.parse(cacheTorneio);
          }
        }

        console.log(times);
        if (!times) {
          if (!torneio) {
            const torneioBase = await api.get("/getTorneioActive");

            torneio = torneioBase.data;
          }

      const    resp = await api.post("/report/getTimes", {
            torneioId: torneio._id,
          });

          times = resp.data;

          // Armazene os dados no cache
          localStorage.setItem(
            CACHE_KEY_JOGADORES,
            JSON.stringify(times)
          );
          localStorage.setItem(
            `${CACHE_KEY_JOGADORES}_timestamp`,
            new Date().getTime().toString()
          );
        }
        console.log(times);

        const jogadoresArray = [];
        Object.entries(times).forEach(([teamName, team]) => {
          team.jogadores.forEach((jogador) => {
            jogadoresArray.push({
              ...jogador,
              teamName: teamName, // Usando a chave como nome do time
            });
          });
        });
        setJogadores(jogadoresArray);
      } catch (error) {
        console.error("Erro ao buscar jogadores:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJogadores();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsVoting(true);
    try {
      await api.post("/votar", {
        apartamento,
        email,
        nome,
        jogadorId: selectedPlayer._id,
      });

      setSuccessMessage("Voto registrado com sucesso!");
      setErrorMessage("");
      setIsError(false);
      setDialogOpen(true);
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response.data.error);
      setSuccessMessage("");
      setIsError(true);
      setDialogOpen(true);
    } finally {
      setIsVoting(false);
    }
  };

  const handlePlayerSelect = (player) => {
    setSelectedPlayer(player);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    if (!isError) {
      navigate("/");
    }
  };

  return (
    <AppLayout>
      <PageHeader backTo="/melhorJogador" eyebrow="Torneio" title="Vote no melhor jogador" subtitle="Um voto por apartamento e por e-mail." />
      <form onSubmit={handleSubmit}>
        <SectionCard title="1. Seus dados" sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              <TextField label="Nome completo" value={nome} onChange={(e) => setNome(e.target.value)} required fullWidth />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField label="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required fullWidth />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField label="Apartamento" value={apartamento} onChange={(e) => setApartamento(e.target.value)} required fullWidth inputProps={{ inputMode: "numeric" }} />
            </Grid>
          </Grid>
        </SectionCard>

        <SectionCard title="2. Escolha o jogador" sx={{ mb: 3 }}>
          {isLoading ? (
            <LoadingState label="Carregando jogadores..." />
          ) : (
            <Grid container spacing={1.5}>
              {jogadores.map((jogador) => {
                const selected = selectedPlayer && selectedPlayer._id === jogador._id;
                return (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={jogador._id}>
                    <Card sx={{ position: "relative", borderColor: selected ? tokens.color.brand : undefined, borderWidth: selected ? 2 : 1, bgcolor: selected ? tokens.color.brandSoft : undefined }}>
                      {selected && <CheckCircleRoundedIcon color="primary" sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }} />}
                      <CardActionArea onClick={() => handlePlayerSelect(jogador)} sx={{ p: 2, textAlign: "center" }}>
                        <PlayerAvatar src={jogador.foto} name={jogador.nome} size={72} sx={{ mx: "auto", mb: 1 }} />
                        <Typography variant="body2" fontWeight={600} noWrap>{jogador.nome}</Typography>
                        <Stack direction="row" spacing={0.75} justifyContent="center" alignItems="center" sx={{ mt: 0.5 }}>
                          <TeamCrest name={jogador.teamName} size={20} />
                          <Typography variant="caption" color="text.secondary">#{jogador.numeroCamisa}</Typography>
                        </Stack>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          )}
        </SectionCard>

        <Card sx={{ p: 2, position: "sticky", bottom: 16 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
              {selectedPlayer && <PlayerAvatar src={selectedPlayer.foto} name={selectedPlayer.nome} size={40} />}
              <Typography noWrap>{selectedPlayer ? <>Seu voto: <strong>{selectedPlayer.nome}</strong></> : "Selecione um jogador"}</Typography>
            </Stack>
            <Button type="submit" variant="contained" size="large" disabled={isVoting || !selectedPlayer}>
              {isVoting ? <CircularProgress size={24} color="inherit" /> : "Confirmar voto"}
            </Button>
          </Stack>
        </Card>
      </form>

      <Backdrop open={isVoting} sx={{ zIndex: 1400, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{isError ? "Não foi possível votar" : "Voto registrado!"}</DialogTitle>
        <DialogContent>
          {isError ? (
            <Alert severity="error">{errorMessage}</Alert>
          ) : (
            <Stack alignItems="center" spacing={1.5}>
              {selectedPlayer && <PlayerAvatar src={selectedPlayer.foto} name={selectedPlayer.nome} size={96} />}
              <Typography>{successMessage}</Typography>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeDialog} variant="contained">OK</Button>
        </DialogActions>
      </Dialog>
    </AppLayout>
  );
};

export default VotarMelhorJogadorPage;
